module.exports = __webpack_public_path__ + "img/product-pension.60fd90ba.svg";